<span>
  {{isShort ? ('SHORT_SERVICE_TYPE.' + serviceType | translate) : ('SERVICE_TYPE.' + serviceType | translate)}}
</span>
